import { CardContent, ScrollArea } from '@ais-ui/ui-core';
import {
  AtonTargetInfo,
  BaseStationTargetInfo,
  DasTargetInfo,
  DroneTargetInfo,
  EnvironmentalTargetInfo,
  MethydTargetInfo,
  RadarTargetInfo,
  RadarFusedTargetInfo,
  ShipInfo,
  TargetInfoType,
  TargetTypeEnum,
  VirtualAtonTargetInfo,
} from '@ais-ui/websockets';
import { BaseStationDetailsPanel } from './BaseStationDetailsPanel';
import { AtonDetailsPanel } from './AtonDetailsPanel';
import { VirtualAtonDetailsPanel } from './VirtualAtonDetailsPanel';
import { MethydDetailsPanel } from './MethydDetailsPanel';
import { EnvironmentalDetailsPanel } from './EnvironmentalDetailsPanel';
import { DasDetailsPanel } from './DasDetailsPanel';
import { RadarDetailsPanel } from './RadarDetailsPanel';
import { RadarFusedDetailsPanel } from './RadarFusedDetailsPanel';
import { DroneDetailsPanel } from './DroneDetailsPanel';
import { ExtendedVesselDetailsPanel } from './ExtendedVesselDetailsPanel';
import { VesselResult } from '@ais-ui/api-spec/shipdb';
import { ShipDetailsPanel } from './ShipDetailsPanel';
import React from 'react';
import { TargetTab } from './targetTypes';

interface TargetInfoDetailsProps {
  targetInfo: TargetInfoType;
  targetType: TargetTypeEnum;
  tab: TargetTab;
}

const TARGET_PANEL_RENDERERS: Partial<
  Record<
    TargetTypeEnum,
    (info: TargetInfoType, tab: TargetTab) => React.ReactNode
  >
> = {
  [TargetTypeEnum.BaseStation]: (info) => (
    <BaseStationDetailsPanel baseStationInfo={info as BaseStationTargetInfo} />
  ),
  [TargetTypeEnum.Aton]: (info) => (
    <AtonDetailsPanel atonInfo={info as AtonTargetInfo} />
  ),
  [TargetTypeEnum.VirtualAton]: (info) => (
    <VirtualAtonDetailsPanel virtualAtonInfo={info as VirtualAtonTargetInfo} />
  ),
  [TargetTypeEnum.Methyd]: (info) => (
    <MethydDetailsPanel methydInfo={info as MethydTargetInfo} />
  ),
  [TargetTypeEnum.Environmental]: (info) => (
    <EnvironmentalDetailsPanel
      environmentalInfo={info as EnvironmentalTargetInfo}
    />
  ),
  [TargetTypeEnum.Das]: (info) => (
    <DasDetailsPanel dasInfo={info as DasTargetInfo} />
  ),
  [TargetTypeEnum.Radar]: (info) => (
    <RadarDetailsPanel radarInfo={info as RadarTargetInfo} />
  ),
  [TargetTypeEnum.RadarFused]: (info) => (
    <RadarFusedDetailsPanel rfInfo={info as RadarFusedTargetInfo} />
  ),
  [TargetTypeEnum.Drone]: (info) => (
    <DroneDetailsPanel droneInfo={info as DroneTargetInfo} />
  ),
  [TargetTypeEnum.ExtendedVessel]: (info, tab) => (
    <ExtendedVesselDetailsPanel shipInfo={info as VesselResult} tab={tab} />
  ),
};

export const TargetInfoDetails = ({
  targetInfo,
  targetType,
  tab,
}: TargetInfoDetailsProps) => {
  const renderer = TARGET_PANEL_RENDERERS[targetType];
  const panel = renderer ? (
    renderer(targetInfo, tab)
  ) : (
    <ShipDetailsPanel shipInfo={targetInfo as ShipInfo} tab={tab} />
  );

  return (
    <CardContent className="flex-1 flex flex-col overflow-hidden">
      <ScrollArea
        className="flex-grow p-0 overflow-y-auto"
        observeResize={false}
      >
        <div className="pr-3">{panel}</div>
      </ScrollArea>
    </CardContent>
  );
};
